/**
 * @description server URLs
 * @todo process.browser deprecated
 */
const HelpServers = new Map([
  [true, process.env.NEXT_PUBLIC_ORIGIN],
  [false, process.env.NGINX_CONTAINER_URL],
]);

/**
 * @todo remove harcoded url for forum
 */
const servers = {
  help: HelpServers,
  forum: 'https://cache.prusa3d.com/forum/wp-json/p3d/v1/forum/', // process.env.NEXT_PUBLIC_FORUM_API_BASE_URL,
  googleVertexSearch:
    'https://discoveryengine.googleapis.com/v1alpha/projects/885017487941/locations/global/collections/default_collection/engines/help-search-web_1738053397528/servingConfigs/default_search:search',
  slicer: 'https://preset-repo-api.prusa3d.com/', // stage: preset-repo-api-stage
};

// const isBrowser = process.browser;
const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined'; // process.browser is deprecated

const helpServerUrl = servers.help.get(isBrowser);

/**
 * @description base paths for rest api endpoints
 */
export const basepath = {
  v1: `${helpServerUrl}/api/v1`,
  v2: `${helpServerUrl}/api/wp/v2`,
  help: `${helpServerUrl}/api/prusuki`,
  edge: `${helpServerUrl}/edge`,
  search: `${helpServerUrl}/search-index`,
  forum: servers.forum,
  googleVertexSearch: servers.googleVertexSearch,
  slicer: `${servers.slicer}v1/repos`,
};
